module.exports = __webpack_public_path__ + "static/NotoSans-Regular.subset-00ee35f926ead7e1ad3427f66dd4d046.otf";